import { post } from './http'

//运动队实时签到信息
export function getSportTeamSign() {
    return post('/tyapi/pc/CompetitionCockpit/getSportTeamSign', {})
}

//重点关注学生(缺训次数)
export function focusOnStudents() {
    return post('/tyapi/pc/CompetitionCockpit/focusOnStudents', {})
}


//运动队每日签到统计
export function dailySportTeamSignStatistics(date) {
    return post('/tyapi/pc/CompetitionCockpit/dailySportTeamSignStatistics', {
        "date":date
    })
}


//运动队列表
export function getSportTeamList() {
    return post('/tyapi/pc/CompetitionCockpit/getSportTeamList', {})
}

//月参训率对比
export function monthlyParticipationRates() {
    return post('/tyapi/pc/CompetitionCockpit/monthlyParticipationRates', {})
}

